<app-organizer-shared-layout-funnel
  class="organizer-activity-creation-page-preview"
>
  <app-organizer-shared-page-container
    [activeStep]="3"
    [hasSingleColumn]="true"
  >
    <app-activity
      [activity]="activity"
      [organization]="organization"
      [organizationReviewsStats]="organizationReviewsStats"
      [isPreview]="true"
    ></app-activity>
    <app-organizer-shared-navigation-buttons
      [nextDisabled]="false"
      [hasNextEmit]="true"
      (clickNext)="toggleShowSuccess()"
    ></app-organizer-shared-navigation-buttons>
  </app-organizer-shared-page-container>

  <app-success-overlay
    *ngIf="showSuccess"
    [successTitle]="successLabels.title"
    [successDescription]="successLabels.description"
    [status]="successStatus"
  >
    <button
      app-vtmn-play-button
      type="button"
      ctaClass="md:mx-auto"
      (click)="clickNextNavigationButtons()"
      [type]="ctaButtonType.Button"
      [variant]="vtmnPlayButtonVariant.PRIMARY"
    >
      {{ successLabels.action }}
    </button>
  </app-success-overlay>
</app-organizer-shared-layout-funnel>
